import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { IDetailsState } from './state';

const state = (state: AppState) => state.detailsState;

export const details_Form = createSelector(
  state,
  (state: IDetailsState) => state.form
);

export const details_DataSaved = createSelector(
  state,
  (state: IDetailsState) => state.dataSaved
);

export const details_Genders = createSelector(
  state,
  (state: IDetailsState) => state.genders
);

export const details_HasError = createSelector(
  state,
  (state: IDetailsState) => state.hasError
);

export const details_IsLoading = createSelector(
  state,
  (state:IDetailsState) => state.isLoading
)